module.exports = __webpack_public_path__ + "static/logo-blue-generate-714830a8c5040874800a3e8c238d4b65.png";